import './footer.css'
import '../pages/ProtoUI.css'
import Robot from '../assets/icons/Illust_Robot.svg'
import GenieSmart from '../assets/icons/GenieSmart.svg'
import GenieClass from '../assets/icons/GenieClass.svg'
import GenieAsk from '../assets/icons/GenieAsk.svg'
import React, {useEffect} from "react";
import Cookies from "js-cookie";

const Footer = () => {
    const [isLoggedIn, setIsLoggedIn] = React.useState(false)

    useEffect(() => {
        const gb_bubbly = Cookies.get('gb_bubbly_cookie')
        if (gb_bubbly === undefined || gb_bubbly === '') {
            setIsLoggedIn(false)
        } else {
            setIsLoggedIn(true)
        }
    }, [])

    return (
        <footer className='flex-col flex-shrink-0 z-50'>
            <div className={`${isLoggedIn ? 'hidden':'block'}`}>
                <a href="https://geniebook.com/" target="_blank" rel="noreferrer">
                    <div className="banner-container flex h-[92px] max-lg:h-fit pt-[22px] pb-[21px]">
                        <div className="content flex-1">
                            <div className="lg:relative float-left flex-row">
                                <div className="lg:absolute lg:-top-[66px] flex-1 float-left">
                                    <img src={Robot} className=" lg:h-[166px] max-sm:h-[150px] max-lg:h-[150px] max-lg:pt-[15px] h-[90px]" alt=""/>
                                </div>
                                <div className="flex-1 banner-text-container">
                                    <div className="max-sm:max-w-[265px] text-[#EFEFF0] text-[16px] text-['Campton'] lg:ml-[152px] ml-[128px]">
                                        To get unlimited access to our suite of AI powered products, sign-up for a 7-day free trial today!
                                    </div>
                                    <div className="max-md:hidden flex mt-[8px] lg:ml-[152px] ml-[128px]">
                                        <img src={GenieSmart} className="h-[22px]" alt="" />
                                        <img src={GenieClass} className="h-[22px] ml-[32px]" alt="" />
                                        <img src={GenieAsk} className="h-[22px] ml-[32px]" alt="" />
                                    </div>
                                </div>
                                <a className="flex-1 h-[80px] block lg:hidden" href="https://geniebook.com/app/create_account/" target="_blank" rel="noreferrer">
                                    <div className="max-lg:float-left float-right mt-4 button-container">
                                        <div className="overflow-hidden text-center transition cursor-pointer button button-orange button-shadow w-[164px] h-[48px]">
                                            <div className="button_bg_hover"></div>
                                            <div className="button_content text-[16px] text-['Campton'] font-extrabold relative leading-[48px]">
                                                Start 7-Day Trial
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <a className="max-lg:hidden" href="https://geniebook.com/app/create_account/" target="_blank" rel="noreferrer">
                                    <div className="max-lg:float-left float-right button-container">
                                        <div className="overflow-hidden text-center transition cursor-pointer button button-orange button-shadow w-[164px] h-[48px]">
                                            <div className="button_bg_hover"></div>
                                            <div className="button_content text-[16px] text-['Campton'] font-extrabold relative leading-[48px]">
                                                Start 7-Day Trial
                                            </div>
                                        </div>
                                    </div>
                                </a>

                        </div>
                    </div>
                </a>
            </div>
            <div className="footer-container">
                <p className="copyright">Copyright 2023 Geniebook Pte Ltd</p>
                <div className="tnc-pp-container">
                    <a href={'https://geniebook.com/terms'} target="_blank" rel="noreferrer" className="tnc-pp mr-[12px]">Terms & Conditions</a>
                    &#x25cf;
                    <a href={'https://geniebook.com/policies/privacy'} target="_blank" rel="noreferrer" className="tnc-pp ml-[12px]">Privacy Policy</a>
                </div>
                <div className="clear-both"></div>
            </div>
        </footer>
    );
}

export default Footer;